import httpService from "V2.0/services/httpService";

export {
  getV2Pipeline,
  listV2Pipelines,
  createV2Pipeline,
  updateV2Pipeline,
  deleteV2Pipeline,
  duplicateV2Pipeline,
  GetV2PipelineRequest,
  CreateV2PipelineRequest,
  ListV2PipelineRequest,
  DeleteV2PipelineRequest,
  UpdateV2PipelineRequest,
  DuplicateV2PipelineRequest,
};

const routes = {
  getV2Pipeline: "/pipelinesV2/whitelabelGet",
  listV2Pipeline: "/pipelinesV2/whitelabelList",
  createV2Pipeline: "/pipelinesV2/whitelabelCreate",
  updateV2Pipeline: "/pipelinesV2/whitelabelUpdate",
  deleteV2Pipeline: "/pipelinesV2/whitelabelDelete",
  duplicateV2Pipeline: "/pipelinesV2/whitelabel/duplicatePipeline",
};

interface GetV2PipelineRequest {
  params: {
    workspaceId: string;
    pipelineId: string;
  };
}

function getV2Pipeline(request: GetV2PipelineRequest) {
  const { params } = request;

  return httpService.get(
    `${routes.getV2Pipeline}/${params.workspaceId}/${params.pipelineId}`,
  );
}

interface CreateV2PipelineRequest {
  params: {
    workspaceId: string;
  };
  body: {
    name: string;
    description?: string;
  };
}

function createV2Pipeline(request: CreateV2PipelineRequest) {
  const { params, body } = request;

  return httpService.post(
    `${routes.createV2Pipeline}/${params.workspaceId}`,
    body,
  );
}

interface ListV2PipelineRequest {
  params: {
    workspaceId: string;
  };
}
function listV2Pipelines(request: ListV2PipelineRequest) {
  const { params } = request;

  return httpService.get(`${routes.listV2Pipeline}/${params.workspaceId}`);
}

interface UpdateV2PipelineRequest {
  params: {
    pipelineId: string;
    workspaceId: string;
  };
  body: {
    name?: string;
    description?: string;
    isActive?: string;
    nodes?: Array<any>;
    edges?: Array<any>;
  };
}
function updateV2Pipeline(request: UpdateV2PipelineRequest) {
  const { params, body } = request;

  return httpService.patch(
    `${routes.updateV2Pipeline}/${params.workspaceId}/${params.pipelineId}`,
    body,
  );
}

interface DuplicateV2PipelineRequest {
  params: {
    workspaceId: string;
    pipelineId: string;
  };
  body: {
    name: string;
  };
}

function duplicateV2Pipeline(request: DuplicateV2PipelineRequest) {
  const { params, body } = request;

  return httpService.post(routes.duplicateV2Pipeline, {
    newPipelineName: body.name,
    originalPipelineId: params.pipelineId,
    workspaceId: params.workspaceId,
  });
}

interface DeleteV2PipelineRequest {
  params: {
    workspaceId: string;
    pipelineId: string;
  };
}

function deleteV2Pipeline(request: DeleteV2PipelineRequest) {
  const { params } = request;

  return httpService.delete(
    `${routes.deleteV2Pipeline}/${params.workspaceId}/${params.pipelineId}`,
  );
}
